import { RDNativeConversion } from '@cibo/core'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const NativeConversionCellDisplay = ({ value }: { value: any }) => {
  const { t } = useTranslation('@cibo/landmanager/NativeConversionEditor')
  if (!value) return null

  const label =
    value.result === 'no' && value.input?.converted === 'unsure'
      ? t('unsure')
      : value.result === 'no' && value.input?.converted === 'no'
      ? t('greaterThanTwentyYearsAgo')
      : value.input?.conversionYear
      ? t('convertedInYear', { year: value.input?.conversionYear })
      : t('lessThanTwentyYearsAgo')

  return (
    <Stack>
      <Typography>{label}</Typography>
      {value.input?.converted === 'yes' && !!value.input?.nativeVegetation && (
        <Typography variant="body2" color="text.secondary">
          {t(`originalUse_${value.input.nativeVegetation}`)}
        </Typography>
      )}
    </Stack>
  )
}

export const NativeConversionCell = ({
  traitId,
  year,
  params,
}: TraitCellDisplayProps<RDNativeConversion>) => {
  const detail = params.row.resolveStandingDetail(traitId, year)
  return <NativeConversionCellDisplay value={detail} />
}
